import React from 'react';

import { AppState } from './app-state.interface';
import { appActions } from './app-actions.type';
import { Alert } from '../../interfaces';

export const AppContext = React.createContext<{
  appState: AppState;
  appStateDispatch: React.Dispatch<appActions>;
  addAlert: (alert: Alert) => void;
}>(Object.assign({}));
